// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f192ab00","455":"3428259b","644":"2cb9d33e"}[chunkId] + ".chunk.js";
};